/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AnalyticsStrictHttpResponse } from '../../analytics-strict-http-response';
import { AnalyticsRequestBuilder } from '../../analytics-request-builder';

import { AnalyticsProductionAnalysisResponseDto } from '../../models/analytics-production-analysis-response-dto';

export interface ProductionAnalysisControllerFindByTenant$Params {
  tenant: string;
}

export function productionAnalysisControllerFindByTenant(http: HttpClient, rootUrl: string, params: ProductionAnalysisControllerFindByTenant$Params, context?: HttpContext): Observable<AnalyticsStrictHttpResponse<Array<AnalyticsProductionAnalysisResponseDto>>> {
  const rb = new AnalyticsRequestBuilder(rootUrl, productionAnalysisControllerFindByTenant.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AnalyticsStrictHttpResponse<Array<AnalyticsProductionAnalysisResponseDto>>;
    })
  );
}

productionAnalysisControllerFindByTenant.PATH = '/o2-analytics/production-analysis/{tenant}';
